<div class="invoice-modal-wrap">
  <!-- HEADER -->
  <div class="invoice-modal-head">
    <div class="head-icon">
      <mat-icon>request_quote</mat-icon>
    </div>
    <div class="head-text">
      <h2 class="head-title">Invoice Details</h2>
      <p class="head-sub">Customise what appears on the printed invoice.</p>
    </div>
    <button mat-icon-button (click)="cancel()" class="head-close"
            aria-label="Close" data-test="tx-invoice-modal-cancel-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- BODY -->
  <div class="invoice-form">
    <div class="form-grid">
      <mat-form-field appearance="outline">
        <mat-label>VAT Reg No</mat-label>
        <input matInput [(ngModel)]="vatRegNo" maxlength="20" data-test="tx-invoice-vat-reg-no" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Invoice Number</mat-label>
        <input matInput [(ngModel)]="invoiceNumber" maxlength="50" data-test="tx-invoice-number" />
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Business Name</mat-label>
      <input matInput [(ngModel)]="businessName" maxlength="100" data-test="tx-invoice-business-name" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Business Address</mat-label>
      <textarea matInput [(ngModel)]="businessAddress" rows="3" maxlength="300"
                data-test="tx-invoice-business-address"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Billed To</mat-label>
      <input matInput [(ngModel)]="billedTo" maxlength="100" data-test="tx-invoice-billed-to" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Notes</mat-label>
      <textarea matInput [(ngModel)]="notes" rows="2" maxlength="300"
                data-test="tx-invoice-notes"></textarea>
    </mat-form-field>
  </div>

  <!-- ACTIONS -->
  <div class="invoice-modal-actions">
    <button mat-button (click)="cancel()" data-test="tx-invoice-cancel-button">Cancel</button>
    <button mat-flat-button color="primary" (click)="generate()" data-test="tx-invoice-generate-button">
      <mat-icon>print</mat-icon>
      Print Invoice
    </button>
  </div>
</div>
